export class MerchantGroup {
  name: string;
  count: number;

  constructor(g: Partial<MerchantGroup>) {
    if (g.name == null)
      throw new Error(
        `Invalid merchant group in constructor: ${JSON.stringify(g)} name cannot be null`,
      );
    if (g.count == null)
      throw new Error(
        `Invalid merchant group in constructor: ${JSON.stringify(g)} count cannot be null`,
      );

    this.name = g.name;
    this.count = g.count;
  }
}
